<script>
	let className = undefined;
	export { className as class };
	export let title = undefined;

	$: rest = $$restProps;
</script>

<svg class="icon icon--minus{className ? ` ${className}`: ''}" focusable="false" role="img" {...rest} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">{#if title}<title>{title}</title>{/if}<!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/></svg>